/**
 * Dashboard API Service
 * Handles all dashboard-related API calls
 */

import { apiClient } from '../client';
import type { DashboardMetrics, CashFlowData, VATSummary } from '../../types/api';

export const dashboardApi = {
  /**
   * Get dashboard metrics
   */
  getMetrics: async (): Promise<DashboardMetrics> => {
    const response = await apiClient.get<DashboardMetrics>('/dashboard/metrics');
    return response.data;
  },

  /**
   * Get cash flow data (12 months)
   */
  getCashFlow: async (): Promise<CashFlowData[]> => {
    const response = await apiClient.get<CashFlowData[]>('/dashboard/cash-flow');
    return response.data;
  },

  /**
   * Get VAT summary
   */
  getVATSummary: async (): Promise<VATSummary> => {
    const response = await apiClient.get<VATSummary>('/dashboard/vat-summary');
    return response.data;
  },

  /**
   * Get top customers by revenue
   */
  getTopCustomers: async (): Promise<any[]> => {
    const response = await apiClient.get('/dashboard/top-customers');
    return response.data;
  },

  /**
   * Get overdue invoices
   */
  getOverdueInvoices: async (): Promise<any[]> => {
    const response = await apiClient.get('/dashboard/overdue-invoices');
    return response.data;
  },

  /**
   * Get expense breakdown by category
   */
  getExpenseCategories: async (): Promise<any[]> => {
    const response = await apiClient.get('/dashboard/expense-categories');
    return response.data;
  },

  /**
   * Get UK compliance status
   */
  getComplianceStatus: async (): Promise<any> => {
    const response = await apiClient.get('/dashboard/compliance-status');
    return response.data;
  },
};

export default dashboardApi;
